import { api } from "./BackendService";

export const listThreads = (page, pageSize = 10) =>
  api.get("/mastra/threads", { params: { page, pageSize } });

export const listThreadMessages = (threadId) =>
  api.get(`/mastra/threads/${threadId}/messages`);
